import { Injectable } from '@angular/core';
import { HttpContext, HttpContextToken, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../_services/loading/loading.service';

/** Marks a request the person did not wait on, such as a search box's suggestions, so it does not show the spinner. */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);

/** The HttpContext for a background request. */
export function backgroundContext(): HttpContext {
  return new HttpContext().set(BACKGROUND_REQUEST, true);
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(BACKGROUND_REQUEST)) {
      return next.handle(request);
    }
    this.loadingService.show();
    return next.handle(request).pipe(
      finalize(() => this.loadingService.hide())
    );
  }
}
